import type { Transcripts } from '@trinity/chat/api/interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { UseDownloaderOptions } from '@trinity/chat-components/containers/QueryDownloader/index.js';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/index.js';

type Data = Transcripts.DownloadSummary.Response;
type Params = ITranscriptId & {
  format: 'pptx' | 'docx';
  tagIds: number[];
};

type Options = Omit<UseDownloaderOptions<Data>, 'queryKey' | 'queryFn'>;

export const useDownloadTranscriptSummary = ({ format, tagIds, transcriptId }: Params, options: Options = {}) => {
  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `get:transcripts/summary/export`,
      transcriptId,
      format,
      tagIds,
    ],
    queryFn: () => {
      return apiClient.transcriptsSummary.downloadSummary({
        format,
        tagIds,
        transcriptId,
      });
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: res.name,
        type: 'blob',
        value: res.file,
      }),
    },
    ...options,
  });
};
